// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8lite","largestCol":"styles_largestCol__f7s6o","smallestCol":"styles_smallestCol__dif8j"};